import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Explore3.css';
import Explore4 from './Explore4';
import Header from '../../components/Header';

const Explore3 = () => {
  const [selectedOption, setSelectedOption] = useState('Woman');
  const [showExplore4, setShowExplore4] = useState(false);
  const navigate = useNavigate();

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    // Chuyển sang Explore 4 sau khi chọn
    setTimeout(() => {
      setShowExplore4(true);
    }, 300);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleCommunityClick = () => {
    navigate('/community');
  };

  const handleVolunteeringClick = () => {
    navigate('/volunteering');
  };

  const handleOrganizationsClick = () => {
    navigate('/book-expert');
  };

  const handleFreeChatClick = () => {
    navigate('/free-chat');
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleExploreTherapyClick = () => {
    navigate('/book-expert');
  };

  const handleChatIconClick = () => {
    navigate('/free-chat');
  };

  // Nếu đã chọn option, hiển thị Explore4
  if (showExplore4) {
    return <Explore4 />;
  }

  const genderOptions = [
    'Woman',
    'Men',
    'Non-binary',
    'Self identify',
    'Prefer not to say'
  ];

  return (
    <div className="explore3-container">
      <Header />

      {/* Main Content */}
      <div className="main-content">
        <div className="white-container">
          <div className="content-wrapper">
            <h1 className="main-title">Help us get to know you</h1>
            <p className="subtitle">Please answer the following questions.</p>
            
            <div className="question-section">
              <h2 className="question">
                What gender do you identify with?
              </h2>
              
              <div className="options-container">
                {genderOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`option-button ${selectedOption === option ? 'selected' : ''}`}
                    onClick={() => handleOptionSelect(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Chat Icon */}
      <div className="chat-icon" onClick={handleChatIconClick} style={{cursor: 'pointer'}}>
        <div className="monitor">
          <div className="screen">
            <div className="face">
              <div className="eyes">
                <span className="eye">"</span>
                <span className="eye">"</span>
              </div>
              <div className="mouth">)</div>
            </div>
          </div>
          <div className="base"></div>
        </div>
      </div>
    </div>
  );
};

export default Explore3;

